// Dependencies
import React from 'react';
import { ThemeContext } from '../../../components/theme/Theme.jsx';
import radium from 'radium';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ShoppingCartImage() {
	const context = React.useContext(ThemeContext);
	const style = {
		imageContainerOuter: {
			display: 'flex',
			width: '100%',
			justifyContent: 'space-around',
			height: '12em',
			alignItems: 'center',
			textAlign: '-webkit-center',

		},
		imageContainer: {
			width: '5em',
			height: '5em',
			borderRadius: '50%',
			backgroundColor: context.themeManager
			.value('shopping-cart', 'backgroundImageIcon', 'fg-color-icon-highlight'),
			margin: '0 0 1em 0',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',

		},
		icon: {
			color: context.themeManager.valueOrDefault('shopping-cart',
					'iconColor', null, '#fff'),
			fontSize: context.themeManager.value('shopping-cart-icon',
				'fontSize', 'font-size-600'),
			margin: '0 .1em 0 0',
		},
	};
	return (
		<div style={style.imageContainerOuter} >
			<div style={style.imageContainer} >
				<FontAwesomeIcon
					icon="shopping-cart"
					style={style.icon}
				/>
			</div>
		</div>
	);
}

export default radium(ShoppingCartImage);
